import React, { useState, useEffect } from "react";

import { Box, Typography, TextField, Grid, Button, Paper } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  createVendor,
  deleteVendor,
  getVendors,
  updateVendor,
} from "../../api/vendor";
import { handleAxiosError } from "../../config/action-config";

import { vendorTable as tableDef } from "../../config/grid-columns-defs";
import ControlledTable from "../../component/ControlledTable";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import UpdateDialog from "../../component/UpdateDialog";
import CreateDialog from "../../component/CreateDialog";
import { showAlert } from "../../actions/alert";
import { useForm, Controller } from "react-hook-form";
import BetterControlledTable from "../../component/BetterControlledTable";

const emptyUpdateData = {
  vendor_name: "",
  company_name: "",
  shipping_address: "",
  billing_address: "",
  contact: "",
  postal_code: "",
  email: "",
  country: "",
  city: "",
  currency: "",
  state: "",
};
const emptyNewVendorData = {
  vendor_name: "",
  company_name: "",
  shipping_address: "",
  billing_address: "",
  contact: "",
  postal_code: "",
  email: "",
  country: "",
  city: "",
  currency: "",
  state: "",
};

export default function Vendor() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [updateDialogOpen, setUpdateDialogeOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const [updateId, setUpdateId] = useState(-1);

  const [updateData, setUpdateData] = useState(emptyUpdateData);
  const [newVendorData, setNewVendorData] = useState(emptyNewVendorData);

  const onNewVendorSubmit = (newVendorData) => {
    createVendor(newVendorData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setNewVendorData(emptyNewVendorData);
        refreshTable();
        setCreateDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setCreateDialogOpen(false);
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "EDIT": {
        setUpdateDialogeOpen(true);
        const up = getUpdatableData(dialogAction.data);
        setUpdateData(up);
        break;
      }
      case "DELETE":
        setDeleteDialogOpen(true);
        break;
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    if (deleteId === -1) return;
    deleteVendor(deleteId, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeleteId(-1);
        refreshTable();
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);

  useEffect(() => {
    if (updateId === -1) return;
    updateVendor(updateId, updateData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setUpdateId(-1);
        setUpdateData(emptyUpdateData);
        refreshTable();
        setUpdateDialogeOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setUpdateId(-1);
        setUpdateDialogeOpen(false);
      });
  }, [updateId]);

  const changeUpdateData = (e) => {
    setUpdateData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    if (!createDialogOpen) {
      setNewVendorData(emptyNewVendorData);
    }
  }, [createDialogOpen]);

  const [queryFilters, setQueryFilters] = useState({ name: "" });
  function onQueryFilterChange({ target }) {
    const { name, value } = target;
    setQueryFilters((prev) => ({ ...prev, [name]: value }));
  }
  const [vendorTableRefreshCount, setVendorTableRefreshCount] = useState(0);
  async function getVendorTableData(limit, offset) {
    try {
      const { data } = await getVendors(
        { limit, offset, sort: "creation_date", ...queryFilters },
        user.token
      );
      let filtersApplied = Object.keys(queryFilters).some(
        (k) => queryFilters[k]
      );
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  function refreshTable(e) {
    e?.preventDefault();
    setVendorTableRefreshCount((prev) => prev + 1);
  }

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Vendors
          </Typography>
        </Box>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="blue-button"
        >
          Add Vendor
        </Button>
      </Box>
      <br />
      <Box
        component="form"
        onChange={refreshTable}
        // sx={{ px: 2, pb: 2, display: "flex", columnGap: 1 }}
        className="pmt-filter-box"
      >
        <TextField
          size="small"
          label="Vendor Name"
          name="name"
          value={queryFilters.name}
          onChange={onQueryFilterChange}
        />
        {/* <Button variant="contained" size="small" type="submit" >Search</Button> */}
      </Box>
      <div className="pmt-controll-table ">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getVendorTableData}
          columns={tableDef}
          perPage={10}
          refreshCounter={vendorTableRefreshCount}
        />
      </div>

      <DeleteAlertDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        setDeleteId={setDeleteId}
        rowId={dialogAction.data?.id}
      />
      <UpdateDialog
        open={updateDialogOpen}
        setOpen={setUpdateDialogeOpen}
        setUpdateId={setUpdateId}
        rowId={dialogAction.data?.id}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="vendor_name"
              fullWidth
              value={updateData.vendor_name}
              onChange={changeUpdateData}
              label="Vendor Name"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="company_name"
              fullWidth
              value={updateData.company_name}
              onChange={changeUpdateData}
              label="Company Name"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="email"
              fullWidth
              value={updateData.email}
              onChange={changeUpdateData}
              label="Email"
              type="email"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="contact"
              fullWidth
              value={updateData.contact}
              error={!/^[0-9]{10}$/.test(updateData.contact)}
              inputProps={{ maxLength: 10 }}
              onChange={changeUpdateData}
              label="Contact"
              type="tel"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={12}>
            <TextField
              margin="dense"
              name="shipping_address"
              fullWidth
              value={updateData.shipping_address}
              onChange={changeUpdateData}
              label="Shipping Address"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={12}>
            <TextField
              margin="dense"
              name="billing_address"
              fullWidth
              value={updateData.billing_address}
              onChange={changeUpdateData}
              label="Billing Address"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="postal_code"
              fullWidth
              value={updateData.postal_code}
              onChange={changeUpdateData}
              label="Postal Code"
              type="number"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="country"
              fullWidth
              value={updateData.country}
              onChange={changeUpdateData}
              label="Country"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="city"
              fullWidth
              value={updateData.city}
              onChange={changeUpdateData}
              label="City"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="state"
              fullWidth
              value={updateData.state}
              onChange={changeUpdateData}
              label="State"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="currency"
              fullWidth
              value={updateData.currency}
              onChange={changeUpdateData}
              label="Currency"
              type="text"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </UpdateDialog>
      <CreateDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onSubmit={handleSubmit(onNewVendorSubmit)}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="vendor_name"
              fullWidth
              // value={newVendorData.vendor_name}
              // onChange={changeNewVendorData}
              label="Vendor Name"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Vendor Name is required.",
              })}
              required
              error={Boolean(errors.vendor_name)}
              helperText={errors.vendor_name?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="company_name"
              fullWidth
              // value={newVendorData.company_name}
              // onChange={changeNewVendorData}
              label="Company Name"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Company Name is required.",
              })}
              required
              error={Boolean(errors.company_name)}
              helperText={errors.company_name?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="email"
              fullWidth
              // value={newVendorData.email}
              // onChange={changeNewVendorData}
              label="Email"
              type="email"
              variant="outlined"
              inputRef={register({
                required: "Email Address  is required.",
                pattern: {
                  value:
                    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  message: "Please enter a valid e-mail address.",
                },
              })}
              required
              error={Boolean(errors.email)}
              helperText={errors.email?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="contact"
              fullWidth
              // value={newVendorData.contact}
              inputProps={{ maxLength: 10 }}
              // onChange={changeNewVendorData}
              label="Contact"
              type="tel"
              variant="outlined"
              inputRef={register({
                required: "Contact Number is required.",
                validate: (value) =>
                  value.length > 9 || "Please enter a valid number",
              })}
              required
              error={Boolean(errors.contact)}
              helperText={errors.contact?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={12}>
            <TextField
              margin="dense"
              name="shipping_address"
              fullWidth
              // value={newVendorData.shipping_address}
              // onChange={changeNewVendorData}
              label="Shipping Address"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Shipping Address is required.",
              })}
              required
              error={Boolean(errors.shipping_address)}
              helperText={errors.shipping_address?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={12}>
            <TextField
              margin="dense"
              name="billing_address"
              fullWidth
              // value={newVendorData.billing_address}
              // onChange={changeNewVendorData}
              label="Billing Address"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Billing Address is required.",
              })}
              required
              error={Boolean(errors.billing_address)}
              helperText={errors.billing_address?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="postal_code"
              fullWidth
              // value={newVendorData.postal_code}
              // onChange={changeNewVendorData}
              label="Postal Code"
              type="number"
              variant="outlined"
              inputRef={register({
                required: "Postal Code is required.",
              })}
              required
              error={Boolean(errors.postal_code)}
              helperText={errors.postal_code?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="country"
              fullWidth
              // value={newVendorData.country}
              // onChange={changeNewVendorData}
              label="Country"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Country Name is required.",
              })}
              required
              error={Boolean(errors.country)}
              helperText={errors.country?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="city"
              fullWidth
              // value={newVendorData.city}
              // onChange={changeNewVendorData}
              label="City"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "City Name is required.",
              })}
              required
              error={Boolean(errors.city)}
              helperText={errors.city?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="state"
              fullWidth
              // value={newVendorData.state}
              // onChange={changeNewVendorData}
              label="State"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "State Name is required.",
              })}
              required
              error={Boolean(errors.state)}
              helperText={errors.state?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="currency"
              fullWidth
              // value={newVendorData.currency}
              // onChange={changeNewVendorData}
              label="Currency"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Currency is required.",
              })}
              required
              error={Boolean(errors.currency)}
              helperText={errors.currency?.message}
            />
          </Grid>
        </Grid>
      </CreateDialog>
    </Box>
  );
}

function getUpdatableData(data) {
  return {
    vendor_name: data.vendor_name,
    company_name: data.company_name,
    email: data.email,
    contact: data.contact,
    shipping_address: data.shipping_address,
    billing_address: data.billing_address,
    postal_code: data.postal_code,
    country: data.country,
    city: data.city,
    currency: data.currency,
    state: data.state,
  };
}
